// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --cgv-blue: #1f4e79;
  --cgv-text: #111111;
  --cgv-bg: #f2f4f7;
  --cgv-white: #ffffff;
  --cgv-table-head: #dbe5f1;
  --cgv-border: #333333;
}

.cgv-page {
  width: 100%;
  min-height: 100vh;
  background: var(--cgv-bg);
  padding: 40px 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: var(--cgv-text);
}

.cgv-document {
  max-width: 1000px;
  margin: 0 auto;
  background: var(--cgv-white);
  padding: 35px 45px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.12);
}

.cgv-document h1 {
  color: var(--cgv-blue);
  text-align: center;
  font-size: 31px;
  line-height: 1.25;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 10px;
}

.cgv-document h2 {
  color: var(--cgv-blue);
  text-align: center;
  font-size: 30px;
  line-height: 1.25;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 15px;
}

.cgv-date {
  text-align: center;
  font-style: italic;
  font-weight: 600;
  margin-bottom: 25px;
}

.cgv-document h3 {
  color: var(--cgv-blue);
  font-size: 25px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 28px 0 15px;
}

.cgv-document h4 {
  color: var(--cgv-blue);
  font-size: 19px;
  font-weight: 700;
  margin: 22px 0 8px;
}

.cgv-document p {
  font-size: 16px;
  line-height: 1.45;
  margin: 8px 0;
  text-align: left;
}

.cgv-document section {
  margin-bottom: 18px;
}

.cgv-table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0 10px;
  font-size: 16px;
}

.cgv-table th {
  background: var(--cgv-table-head);
  border: 1px solid var(--cgv-border);
  padding: 7px 10px;
  text-align: left;
  font-weight: 700;
}

.cgv-table td {
  border: 1px solid var(--cgv-border);
  padding: 7px 10px;
  vertical-align: top;
}

.cgv-table td:first-child {
  width: 50%;
}

.cgv-list {
  margin: 10px 0 20px 25px;
  padding: 0;
}

.cgv-list li {
  font-size: 16px;
  line-height: 1.55;
  margin-bottom: 5px;
}

@media print {
  .cgv-page {
    background: white;
    padding: 0;
  }

  .cgv-document {
    box-shadow: none;
    max-width: none;
    padding: 25px;
  }

  .cgv-document h1 {
    font-size: 26px;
  }

  .cgv-document h2 {
    font-size: 25px;
  }

  .cgv-document h3 {
    font-size: 21px;
  }

  .cgv-document h4,
  .cgv-document p,
  .cgv-table,
  .cgv-list li {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .cgv-page {
    padding: 15px 10px;
  }

  .cgv-document {
    padding: 22px 18px;
  }

  .cgv-document h1 {
    font-size: 24px;
  }

  .cgv-document h2 {
    font-size: 23px;
  }

  .cgv-document h3 {
    font-size: 20px;
  }

  .cgv-document h4 {
    font-size: 17px;
  }

  .cgv-document p,
  .cgv-table,
  .cgv-list li {
    font-size: 14px;
  }

  .cgv-table {
    display: block;
    overflow-x: auto;
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/footer/cgv-cgu.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[":root {\n  --cgv-blue: #1f4e79;\n  --cgv-text: #111111;\n  --cgv-bg: #f2f4f7;\n  --cgv-white: #ffffff;\n  --cgv-table-head: #dbe5f1;\n  --cgv-border: #333333;\n}\n\n.cgv-page {\n  width: 100%;\n  min-height: 100vh;\n  background: var(--cgv-bg);\n  padding: 40px 15px;\n  font-family: Arial, Helvetica, sans-serif;\n  color: var(--cgv-text);\n}\n\n.cgv-document {\n  max-width: 1000px;\n  margin: 0 auto;\n  background: var(--cgv-white);\n  padding: 35px 45px;\n  box-shadow: 0 0 18px rgba(0, 0, 0, 0.12);\n}\n\n.cgv-document h1 {\n  color: var(--cgv-blue);\n  text-align: center;\n  font-size: 31px;\n  line-height: 1.25;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 0 0 10px;\n}\n\n.cgv-document h2 {\n  color: var(--cgv-blue);\n  text-align: center;\n  font-size: 30px;\n  line-height: 1.25;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 0 0 15px;\n}\n\n.cgv-date {\n  text-align: center;\n  font-style: italic;\n  font-weight: 600;\n  margin-bottom: 25px;\n}\n\n.cgv-document h3 {\n  color: var(--cgv-blue);\n  font-size: 25px;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 28px 0 15px;\n}\n\n.cgv-document h4 {\n  color: var(--cgv-blue);\n  font-size: 19px;\n  font-weight: 700;\n  margin: 22px 0 8px;\n}\n\n.cgv-document p {\n  font-size: 16px;\n  line-height: 1.45;\n  margin: 8px 0;\n  text-align: left;\n}\n\n.cgv-document section {\n  margin-bottom: 18px;\n}\n\n.cgv-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 12px 0 10px;\n  font-size: 16px;\n}\n\n.cgv-table th {\n  background: var(--cgv-table-head);\n  border: 1px solid var(--cgv-border);\n  padding: 7px 10px;\n  text-align: left;\n  font-weight: 700;\n}\n\n.cgv-table td {\n  border: 1px solid var(--cgv-border);\n  padding: 7px 10px;\n  vertical-align: top;\n}\n\n.cgv-table td:first-child {\n  width: 50%;\n}\n\n.cgv-list {\n  margin: 10px 0 20px 25px;\n  padding: 0;\n}\n\n.cgv-list li {\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 5px;\n}\n\n@media print {\n  .cgv-page {\n    background: white;\n    padding: 0;\n  }\n\n  .cgv-document {\n    box-shadow: none;\n    max-width: none;\n    padding: 25px;\n  }\n\n  .cgv-document h1 {\n    font-size: 26px;\n  }\n\n  .cgv-document h2 {\n    font-size: 25px;\n  }\n\n  .cgv-document h3 {\n    font-size: 21px;\n  }\n\n  .cgv-document h4,\n  .cgv-document p,\n  .cgv-table,\n  .cgv-list li {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .cgv-page {\n    padding: 15px 10px;\n  }\n\n  .cgv-document {\n    padding: 22px 18px;\n  }\n\n  .cgv-document h1 {\n    font-size: 24px;\n  }\n\n  .cgv-document h2 {\n    font-size: 23px;\n  }\n\n  .cgv-document h3 {\n    font-size: 20px;\n  }\n\n  .cgv-document h4 {\n    font-size: 17px;\n  }\n\n  .cgv-document p,\n  .cgv-table,\n  .cgv-list li {\n    font-size: 14px;\n  }\n\n  .cgv-table {\n    display: block;\n    overflow-x: auto;\n    white-space: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
